// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/DimensionSet.yaml
// Generated: 2026-05-31T18:49:06.876Z
// </auto-generated>

import { ReadOnlyEntityService } from '@/lib/EntityService';
import { DimensionSet } from '@/types/finance/DimensionSet';

/**
 * DimensionSet Service (Read-Only)
 * Query operations for DimensionSet via the ABP API.
 */
export const dimensionSetService = new ReadOnlyEntityService<DimensionSet>(
  '/api/finance/dimensionset',
  'DimensionSet',
);
